<template>
  <el-container class="fullheight">
    <el-aside width="230px" style="overflow-x: hidden; border: 1px solid #eee">
      <eco-select v-model="selectOrgId" class="org-select" :options="orgList" @change="demChange" />
      <eco-tree
        :data="treeData"
        :props="defaultProps"
        node-key="id"
        highlight-current
        :expand-on-click-node="false"
        :support-filter="true"
        @node-click="orgTreeClick"
        @refresh="handleRefresh"
        ref="ecoTree"
        class="orgTree"
      >
      </eco-tree>
    </el-aside>
    <el-container>
      <el-main class="fullheight">
        <eco-table
          @load="loadData"
          :data="data"
          :pageResult="pageResult"
          :selection="true"
          :default-sorter="[{ direction: 'DESC', property: 'updateTime' }]"
          quick-search-props="account,fullname,mobile"
          :show-custom-column="false"
          :show-export="false"
          ref="ecoTable"
        >
          <template v-slot:toolbar>
            <el-button @click="iExport" type="primary">下载用户模板</el-button>
            <el-button @click="iImport" class="marginRight16">导入用户</el-button>
            <el-button size="small" @click="showDialog()" class="marginRight16">添加</el-button>
            <fe-delete-button class="marginRight16" :url="userDeleteUrl" :htTable="$refs.ecoTable" @after-delete="afterDelete">删除</fe-delete-button>
            <!-- <el-button size="small" @click="beforeSynchronization()" icon="icon-wechat-fill">同步微信通讯录</el-button> -->
            <el-button size="small" v-if="showExcel" @click="excelImport()">Excel导入</el-button>
          </template>
          <template v-slot:search>
            <eco-table-search-panel :divide="3">
              <eco-table-search-field label="姓名" prop="fullname" placeholder="请输入姓名" />
              <eco-table-search-field label="账号" prop="account" placeholder="请输入账号" />
              <eco-table-search-field label="邮箱" prop="email" placeholder="请输入邮箱" />
              <eco-table-search-field label="电话" prop="mobile" placeholder="请输入电话" />
              <eco-table-search-field label="岗位" prop="POST_NAME_" placeholder="请选择岗位名称" />
              <eco-table-search-field label="职务" prop="JOB_NAME_" placeholder="请选择职务名称" />
              <eco-table-search-field label="角色" prop="ROLE_NAME_" placeholder="请选择角色名称" />
              <!--<eco-table-search-field type="select" :options="posts" label="岗位" prop="POST_NAME_" placeholder="请选择岗位名称" />
              <eco-table-search-field type="select" :options="jobs" label="职务" prop="JOB_NAME_" placeholder="请选择职务名称" />
              <eco-table-search-field type="select" :options="roles" label="角色" prop="ROLE_NAME_" placeholder="请选择角色名称" />-->
            </eco-table-search-panel>
          </template>
          <template>
            <eco-table-column type="index" width="50" align="center" label="序号" />
            <eco-table-column prop="fullname" label="名称" :sortable="true" :show-overflow-tooltip="true">
              <template v-slot="{ row }">
                <el-link type="primary" @click="handleCommand({ row: row, command: 'showInfo' })" title="查看详情">{{ row.fullname }}</el-link>
              </template>
            </eco-table-column>
            <eco-table-column prop="account" label="账号" :sortable="true" />
            <eco-table-column prop="email" label="邮箱" />
            <eco-table-column prop="mobile" label="电话" sortable />
            <eco-table-column
              prop="sex"
              label="性别"
              width="80"
              :filters="[
                { text: '男士', value: '男' },
                { text: '女士', value: '女' }
              ]"
            >
              <template v-slot="{ row }">
                <el-tag v-if="row.sex == '男'">男士</el-tag>
                <el-tag type="success" v-if="row.sex == '女'">女士</el-tag>
              </template>
            </eco-table-column>
            <eco-table-column
              prop="status"
              label="状态"
              width="110"
              :filters="[
                { text: '禁用', value: '0' },
                { text: '正常', value: '1' },
                { text: '离职', value: '-2' }
              ]"
            >
              <template v-slot="{ row }">
                <el-tag type="warning" v-if="row.status == 0">禁用</el-tag>
                <el-tag v-if="row.status == 1">正常</el-tag>
                <el-tag type="info" v-if="row.status == -2">离职</el-tag>
              </template>
            </eco-table-column>
            <eco-table-column width="150" label="操作">
              <template v-slot="{ row }">
                <el-dropdown size="mini" @command="handleCommand">
                  <el-link type="primary" :underline="false"> 编辑<i class="el-icon-arrow-down el-icon--right"></i> </el-link>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="{ row: row, command: 'edit' }">编辑</el-dropdown-item>
                    <el-dropdown-item :command="{ row: row, command: 'generateTicket' }">生成认证Key</el-dropdown-item>
                    <el-dropdown-item :command="{ row: row, command: 'updatePwd' }">重置密码</el-dropdown-item>
                    <el-dropdown-item :command="{ row: row, command: 'toFront' }" v-if="row.status == 1">前端登录</el-dropdown-item>
                    <el-dropdown-item :command="{ row: row, command: 'toManager' }" v-if="row.status == 1">管理端登录</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <!-- <el-button size="mini" @click="handleCommand({row:row,command:'edit'})">编辑</el-button>
                <el-button size="mini" @click="handleCommand({row:row,command:'updatePwd'})">重置密码</el-button>-->
              </template>
            </eco-table-column>
          </template>
        </eco-table>

        <el-drawer
          class="sideDrawer"
          :size="drawerSize"
          destroy-on-close
          :title="dialogTitle"
          :visible="isUserManagerShow"
          :before-close="handleCloseUserManager"
          ref="userManagerref"
          :close-on-click-modal="false"
          append-to-body
        >
          <i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
          <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
          <!--编辑用户面板-->
          <user-manager
            style="padding: 0 20px"
            ref="userManager"
            :user-account="clickUserAccount"
            v-if="isUserManagerShow"
            @handleCloseUserManager="handleCloseUserManager"
            @closeUserManeger="closeUserManeger"
          ></user-manager>
        </el-drawer>

        <el-dialog width="28%" title="查看用户" :visible.sync="isUserInfo" destroy-on-close append-to-body :before-close="handleCloseUserManager">
          <div style="padding: 20px">
            <user-detail :user="user" />
          </div>
        </el-dialog>

        <el-dialog destroy-on-close width="28%" title="重置密码" :visible="isUpdatePwd" append-to-body :before-close="handleCloseUserManager">
          <el-form v-model="password" style="padding: 20px">
            <eco-form-item label="请输入密码" prop="name" label-width="100px">
              <eco-input v-model="password.pwd" autocomplete="off" :validate="pwdValidate" placeholder="请输入密码" show-password></eco-input>
            </eco-form-item>
            <eco-form-item label="确认密码" prop="name" label-width="100px">
              <eco-input v-model="password.newPwd" autocomplete="off" :validate="{ required: true }" placeholder="确认密码" show-password></eco-input>
            </eco-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="updatePwd()" type="primary">修改</el-button>
            <el-button @click="dialogCancle('isUpdatePwd')">{{ $t('eip.common.cancel') }}</el-button>
          </div>
        </el-dialog>
        <fe-load-data :url="loadDataUrl" context="uc" @after-load-data="afterLoadData"></fe-load-data>
        <!-- 角色用户管理 -->
        <user-role-manager ref="userRoleManager"></user-role-manager>
        <!-- 分类对话框  -->
        <eip-sys-type-dialog ref="flowTypeDialog" cat-id="6"></eip-sys-type-dialog>

        <el-dialog
          append-to-body
          title="导入Excel"
          :visible.sync="importDialogVisible"
          width="40%"
          top="30vh"
          :close-on-click-modal="false"
          v-if="importDialogVisible"
        >
          <div style="height: 260px; padding-left: 20px">
            <el-row class="import_row">
              <el-col :span="20">
                <span>组织维度: </span>
                <eco-select v-model="importDemCode" class="org-select" :options="demList" />
              </el-col>
              <el-col :span="4">
                <el-button size="small" type="primary" icon="el-icon-download" @click="downloadTemplate()">模板下载</el-button>
              </el-col>
            </el-row>
            <el-row class="import_row">
              <span>导入文件: </span>
              <el-upload
                style="display: inline-block"
                :action="importUserUrl"
                :on-success="hadleUploadResult"
                :on-error="hadleUploadResult"
                :headers="uploadHeaders"
                :on-exceed="onExceed"
                accept=".xlsx"
                :before-upload="beforeUpload"
                :limit="1"
                :data="{ isCheck: true }"
                :auto-upload="false"
                ref="upload"
              >
                <el-button size="small" icon="el-icon-upload">选择Excel文件</el-button>
              </el-upload>
            </el-row>
            <el-row class="import_row">
              <span style="color: red">导入须知: </span>
              <span>
                导入数据需按模板指定格式进行导入：1、姓名、帐号等字段为必填字段，必填字段请按照批注严格填写；2、组织岗位导入规则：每个用户绑定一个主组织(部门)，每个部门绑定一个主负责人；根据性质填写岗位和组织，性质=组织
                填写 组织编码，组织名称，是否是负责人，是否是主组织，性质=岗位 填写 岗位编码，岗位名称
                3、邮箱格式必须符合标准，将不导入不符合规范的邮箱数据；4、导入后如果有未导入的信息，将会自动下载检查结果；5、填写所属角色时，请确保模板中的流程角色至少匹配一名用户；6、不要编辑数据字典中的内容
              </span>
            </el-row>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitImport" element-loading-text="拼命导入中" v-loading.fullscreen.lock="fullscreenLoading">确 定</el-button>
            <el-button @click="importDialogVisible = false">取 消</el-button>
          </div>
        </el-dialog>

        <el-dialog
          width="70%"
          append-to-body
          title="导入用户"
          class="sp-manager__dialog"
          :visible="importShow"
          :close-on-click-modal="false"
          :before-close="beforeCloseimport"
          @dialogclose="beforeCloseimport"
          :destroy-on-close="true"
        >
          <div slot="title" class="dialog-header-title">
            <span class="name">导入用户</span>
          </div>
          <eip-import-material
            model-name="importList"
            permission="w"
            propConf='[{"name":"prop1"}]'
            accept="xlsx,xls"
            limit="1"
            displayType="table"
            :multiple="false"
            :importsuccess="true"
            :importurl="importurl"
          >
          </eip-import-material>
          <el-row class="import_row">
            <span style="color: red">导入须知: </span>
            <span>
              导入数据需按模板指定格式进行导入：1、姓名、帐号等字段为必填字段，必填字段请按照批注严格填写；2、组织岗位导入规则：每个用户绑定一个主组织(部门)，每个部门绑定一个主负责人；根据性质填写岗位和组织，性质=组织
              填写 组织编码，组织名称，是否是负责人，是否是主组织，性质=岗位 填写 岗位编码，岗位名称 3、邮箱、手机号、生日
              格式必须符合标准，将不导入不符合规范的邮箱数据；4、导入后如果有未导入的信息，将会自动下载成excel文件，请认真核对；5、填写所属角色时，请确保模板中的流程角色至少匹配一名用户；6、不要编辑数据字典中的内容
            </span>
          </el-row>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" size="mini" element-loading-text="拼命导入中" @click="beforeCloseimport">完 成</el-button>
          </div>
        </el-dialog>
        <!--生成认证key-->
        <eco-sidebar-dialog destroy-on-close width="28%" title="生成认证key" :visible="isGenerateTicket" append-to-body :before-close="handleCloseUserManager">
          <el-form v-model="ticket" style="padding: 20px">
            <eco-form-item label="请输入有效期" prop="timeout" label-width="100px">
              <eco-input v-model="ticket.timeout" type="number" placeholder="请输入有效期"></eco-input>
            </eco-form-item>
          </el-form>
          <span style="color: red">生成Key：{{ ticketValue }} </span><br />
          <span style="color: red">生成须知: </span>
          <span> 请填入认证Key有效期，单位:秒，如果填入 -1 则表示永久不过期 </span>
          <div class="demo-drawer__footer">
            <el-button @click="dialogCancle('isGenerateTicket')">{{ $t('eip.common.cancel') }} </el-button>
            <el-button @click="generateTicket()" type="primary"> 生成 </el-button>
          </div>
        </eco-sidebar-dialog>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
import uc from '@/api/uc.js'
import org from '@/api/org.js'
import sys from '@/api/portal.js'
import utils from '@/eco-ui-util.js'
import UserManager from './UserManager'
import UserDetail from './UserDetail'
import eipImportMaterial from '@/components/eipControl/EipImportMaterial.vue'
import EipUserDialog from '@/components/dialog/EipUserDialog.vue'
const UserRoleManager = () => import('@/views/uc/UserRoleManager.vue')
const EipSysTypeDialog = () => import('@/components/dialog/EipSysTypeDialog.vue')

export default {
  components: {
    EipUserDialog,
    UserRoleManager,
    EipSysTypeDialog,
    UserManager,
    UserDetail,
    eipImportMaterial
  },
  computed: {
    userDeleteUrl: function () {
      return window.context.uc + '/api/user/v1/user/deleteUserByIds'
    },
    saveUserUrl: function () {
      let preUrl = window.context.uc + '/api/user/v1/user'
      if (this.user.id) {
        preUrl += '/updateUser'
      } else {
        preUrl += '/addUser'
      }
      return preUrl
    },
    requestMethod: function () {
      return this.role.id ? 'PUT' : 'POST'
    },
    roleCodesOptions: function () {
      let result = []
      for (let role of this.allowRoles) {
        let obj = {}
        obj.key = role.code
        obj.value = role.name
        result.push(obj)
      }
      return result
    },
    saveRoleCopy: function () {
      return `${window.context.portal}/sys/sysRoleAuth/v1/saveCopy?oldCode=${this.menuPerm.code}&newCodes=${this.menuPerm.newCodes}`
    },
    importUserUrl: function () {
      return window.context.uc + '/api/user/v1/users/importExcelUser?demCode=' + this.importDemCode
    },
    uploadHeaders: function (mapState) {
      return {
        Authorization: 'Bearer ' + this.$store.state.login.currentUser.token
      }
    }
  },
  data() {
    return {
      drawerSize: '70%',
      selectOrgId: '',
      selectOrgName: '',
      orgList: [], //下拉框待选择的组织
      demList: [], //下拉框待选择的维度
      treeData: [], //树形菜单展示的数组
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      reFresh: true,
      dialogVisible: false,
      isUserManagerShow: false,
      showExcel: false,
      role: {
        name: '',
        code: ''
      },
      user: {
        account: '',
        address: '',
        email: '',
        fullname: '',
        mobile: '',
        password: '',
        photo: '',
        sex: '',
        status: 1,
        roleName: '',
        orgPostList: []
      },
      isSubmit: true,
      data: [],
      pageResult: {
        page: 1,
        pageSize: 50,
        total: 0
      },
      loadDataUrl: '',
      menuPerm: {},
      allowRoles: [],
      fileList: [],
      img: '',
      clickUserAccount: '', //当前点击用户的用户账号
      isUserInfo: false,
      isUpdatePwd: false,
      password: {
        pwd: '',
        newPwd: ''
      },
      pwdValidate: {
        required: true,
        min: 6
      },
      dialogTitle: '',
      roles: [],
      jobs: [],
      posts: [],
      importDialogVisible: false,
      importDemCode: '',
      importShow: false,
      importurl: '/api/user/v1/importXlsx',
      isGenerateTicket: false,
      ticket: {
        userId: null,
        timeout: 60
      },
      ticketValue: ''
    }
  },
  mounted() {
    this.$validator = this.$root.$validator
    //维度-组织数据
    this.getAllDemList()
    //获取用户导入按钮参数
    this.getUserExcel()
    //默认密码策略
    //this.loadPwdStratege();
    /*//加载全部角色
    this.getAllRoles();
    //加载全部职务
    this.getAllJobs();
    //加载全部岗位
    this.getAllPosts();*/
  },
  methods: {
    iExport() {
      let param = []
      this.$http.get('${business}/system/context/template?fileKey=export-template/用户模板.xlsx', 'arraybuffer').then((resp) => {})
    },
    iImport() {
      this.importShow = true
    },
    beforeCloseimport() {
      this.importShow = false
    },
    getUserExcel() {
      let this_ = this
      this.$http.get('${portal}/sys/sysProperties/v1/getByAlias?alias=userExcel').then(function (resp) {
        if (resp.data) {
          this_.showExcel = true
        }
      })
    },
    demChange(data) {
      this.selectOrgId = data
      this.loadTreeData()
    },
    orgTreeClick(orgbytree) {
      //重置数据
      let ary = this.$refs.ecoTable.querys
      for (var i = 0; i < ary.length; i++) {
        if (ary[i].group && ary[i].group == 'orgTree') {
          ary.remove(ary[i])
        }
      }
      if (!orgbytree.code) {
        this.$refs.ecoTable.querys.push({
          property: 'DEM_ID_',
          value: orgbytree.demId,
          group: 'orgTree',
          relation: 'AND',
          operation: 'EQUAL'
        })
      } else {
        let ids = []
        let trees = ''
        this.getOrgTrees(orgbytree, ids)
        trees = ids.join(',')
        if (trees != '') {
          this.$refs.ecoTable.querys.push({
            property: 'ORG_ID_',
            value: trees,
            group: 'orgTree',
            relation: 'AND',
            operation: 'IN'
          })
        }
      }
      this.$refs.ecoTable.load()
    },
    getOrgTrees(node, ids) {
      ids.push(node.id)
      let arr = node.children
      if (arr) {
        for (var i = 0; i < arr.length; i++) {
          this.getOrgTrees(arr[i], ids)
        }
      }
    },
    handleRefresh(cb) {
      this.loadTreeData(cb)
      //重置数据
      let ary = this.$refs.ecoTable.querys
      for (var i = 0; i < ary.length; i++) {
        if (ary[i].group && ary[i].group == 'orgTree') {
          ary.remove(ary[i])
        }
      }
      this.$refs.ecoTable.load()
    },
    getAllDemList() {
      org
        .getDescAll()
        .then((rep) => {
          for (var i = 0; i < rep.length; i++) {
            this.orgList.push({
              key: rep[i].id,
              value: rep[i].demName
            })
            this.demList.push({
              key: rep[i].code,
              value: rep[i].demName
            })
            if (rep[i].isDefault === 1) {
              this.selectOrgId = rep[i].id
              return this.selectOrgId
            }
          }
        })
        .then((params) => {
          var dem = {
            demId: params
          }
          org.getByParentAndDemToTree(dem).then((data) => {
            this.treeData = utils.tile2nest(data)
            console.log(this.treeData, 555)
            this.$forceUpdate()
          })
        })
    },
    loadTreeData(cb) {
      var param = {
        demId: this.selectOrgId
      }
      org.getByParentAndDemToTree(param).then((data) => {
        this.treeData = utils.tile2nest(data)
        cb && cb()
      })
    },
    loadPwdStratege() {
      uc.getDefaultPwdStrategy().then((data) => {
        if (data) {
          let form = data
          if (form.enable == 1) {
            let pwdRule = form.pwdRule
            let pwdLength = form.pwdLength
            if (pwdRule == 1) {
              this.pwdValidate = {
                required: true,
                min: pwdLength
              }
            } else {
              let regex = {}
              if (pwdRule == 2) {
                regex = {
                  exp: '^(?=.*[0-9])(?=.*[a-zA-Z]).{' + pwdLength + ',30}$',
                  message: '密码必须包含字母、数字,至少' + pwdLength + '位'
                }
              } else if (pwdRule == 3) {
                regex = {
                  exp: '^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{' + pwdLength + ',30}$',
                  message: '密码必须包含数字、字母、特殊字符,至少' + pwdLength + '位'
                }
              } else if (pwdRule == 4) {
                regex = {
                  exp: '^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{' + pwdLength + ',30}$',
                  message: '密码必须包含数字、大小写字母、特殊字符,至少' + pwdLength + '位'
                }
              }
              this.pwdValidate = {
                required: true,
                regex: regex
              }
            }
          }
        }
      })
    },
    onBeforeUploadImage(file) {
      const isIMAGE = file.type === 'image/jpeg' || 'image/jpg' || 'image/png'
      const isLt1M = file.size / 1024 / 1024 < 1
      if (!isIMAGE) {
        this.$message.error('上传文件只能是图片格式!')
      }
      if (!isLt1M) {
        this.$message.error('上传文件大小不能超过 1MB!')
      }
      return isIMAGE && isLt1M
    },
    UploadImage(param) {
      //执行文件上传
      const formData = new FormData()
      formData.append('files', param.file)
      uc.fileUpload(formData)
        .then((response) => {
          this.user.photo = '/system/file/v1/downloadFile?fileId=' + response.fileId
          param.onSuccess() // 上传成功的图片会显示绿色的对勾
        })
        .catch((response) => {
          param.onError()
        })
    },
    handleClose() {
      this.dialogVisible = false
    },
    handleCloseUserManager(data = true) {
      this.isUserManagerShow = false
      this.isUserInfo = false
      this.isUpdatePwd = false
      this.password = {}
      this.clickUserAccount = ''
      if (!data) this.$refs.ecoTable.load()
    },
    showDialog(row) {
      this.dialogTitle = '添加用户'
      this.isUserManagerShow = false
      this.$nextTick(() => {
        this.isUserManagerShow = true
      })
    },
    dialogCancle(dialogVisible) {
      this[dialogVisible] = false
    },
    loadData(param, cb) {
      uc.getOrgUserQuery(param)
        .then((response) => {
          this.data = response.rows
          this.pageResult = {
            page: response.page,
            pageSize: response.pageSize,
            total: response.total
          }
        })
        .finally(() => cb())
    },
    handleCommand(params) {
      switch (params.command) {
        case 'edit':
          this.dialogTitle = '编辑用户'
          this.clickUserAccount = params.row.account
          this.isUserManagerShow = false
          this.$nextTick(() => {
            this.isUserManagerShow = true
          })
          break
        case 'showInfo':
          this.selectUserInfo(params.row.account)
          break
        case 'updatePwd':
          this.user = params.row
          this.isUpdatePwd = true
          break
        case 'generateTicket':
          this.ticket.userId = params.row.userId
          uc.getTicketByUserId(params.row.userId)
            .then((resp) => {
              this.ticketValue = resp
            })
            .finally(() => {
              this.isGenerateTicket = true
            })
          break
        case 'toFront':
          uc.getTicket(params.row.userId).then((resp) => {
            if (resp) {
              window.open(`${window.context.front3}/login?ticket=` + resp + '&tenantId=' + params.row.tenantId + '&account=' + params.row.account)
            }
          })
          break
        case 'toManager':
          uc.getTicket(params.row.userId).then((resp) => {
            if (resp) {
              window.open(`${window.context.manage}/login?ticket=` + resp + '&tenantId=' + params.row.tenantId + '&account=' + params.row.account)
            }
          })
          break
        default:
          break
      }
    },
    async beforeSaveData() {
      this.isSubmit = true
    },
    afterSaveData() {
      this.dialogVisible = false
      this.$refs.ecoTable.load()
    },
    afterDelete() {
      this.$refs.ecoTable.load()
    },
    afterLoadData(data) {
      // 菜单权限复制
      if (this.isUserManagerShow) {
        this.allowRoles = data
      }
      // 编辑角色
      if (this.dialogVisible) {
        this.role = data.value
        setTimeout(() => this.$validator.validateAll('editRoleForm'))
      }
    },
    showFlowTypeDialog() {
      this.$refs.flowTypeDialog.showDialog()
    },
    selectUserInfo(account) {
      //查询用户的详细信息
      uc.getUser(account)
        .then((resp) => {
          resp.photo = `${window.context.portal}` + resp.photo
          this.user = { ...resp.user }
        })
        .then(() => {
          // 查询所属组织岗位，所属角色信息
          uc.getUserByUserId(this.user.id).then((resp) => {
            this.$set(this.user, 'roleName', resp[resp.length - 1].roleName.roleName)
            let _orgPostList = []
            for (var i = 0; i < resp.length - 1; i++) {
              _orgPostList.push(resp[i])
            }
            this.$set(this.user, 'orgPostList', _orgPostList)
            this.isUserInfo = true
          })
        })
    },
    beforeSynchronization() {
      var users = this.$refs.ecoTable.$refs.ecoTable.selection
      let userIds = users.map((obj) => {
        return obj.userId
      })
      uc.syncUserToWx(userIds).then(() => {
        this.$refs.ecoTable.load()
      })
    },
    updatePwd() {
      if (this.password.pwd != this.password.newPwd) {
        this.$message.error('两次输入密码不一致')
        return
      } else if (this.password.newPwd == '' || this.password.newPwd == null) {
        this.$message.error('请输入密码')
        return
      } else if (this.password.newPwd.length < 6) {
        this.$message.error('密码长度必须到6位')
        return
      }
      var param = {
        account: this.user.account,
        newPwd: this.password.newPwd
      }
      uc.updateUserPsw(param).then(() => {
        this.$message({
          message: '修改成功！',
          type: 'success'
        })
        this.isUpdatePwd = false
        this.password = {}
      })
    },
    closeUserManeger() {
      this.handleCloseUserManager()
    },
    excelImport() {
      this.fullscreenLoading = false
      this.importDialogVisible = true
    },
    getAllRoles() {
      uc.getAllRoles().then((data) => {
        data.forEach((item) => {
          this.roles.push({
            key: item.name,
            value: item.name
          })
        })
      })
    },
    getAllJobs() {
      uc.getAllJobs().then((data) => {
        data.forEach((item) => {
          this.jobs.push({
            key: item.name,
            value: item.name
          })
        })
      })
    },
    getAllPosts() {
      uc.getAllPosts().then((data) => {
        data.rows.forEach((item) => {
          this.posts.push({
            key: item.name,
            value: item.name
          })
        })
      })
    },
    getTokenByUserName(username) {
      let token = ''
      uc.getTokenByUserName(username).then((resp) => {
        token = resp.value
      })
      return token
    },
    onExceed(file) {
      this.$message.warning('只能选择一个Excel文件!')
    },
    submitImport() {
      if (!this.$refs.upload.uploadFiles || this.$refs.upload.uploadFiles.length == 0) {
        this.$message.warning('请选择要导入的流程!')
        return false
      }
      if (!this.importDemCode) {
        this.$message.warning('请选择要导入的维度!')
        return false
      }
      this.$refs.upload.submit()
    },
    beforeUpload(file) {
      if (!file.name.endsWith('.xlsx')) {
        this.$message.warning('只能导入Excel文件!')
        return false
      }
      this.fullscreenLoading = true
    },
    hadleUploadResult(response, file, fileList) {
      this.fullscreenLoading = false
      if (response.state) {
        this.$message.success(response.message)
        this.importDialogVisible = false
        this.$refs.ecoTable.load()
      } else {
        this.$message.error(response.message + '：' + response.value)
      }
    },
    downloadTemplate() {
      window.location.href = '/static/excel/导入组织用户模板_标准.xlsx'
    },
    generateTicket() {
      uc.getTicket(this.ticket.userId, this.ticket.timeout).then((resp) => {
        this.ticketValue = resp
      })
    }
  }
}
</script>
<style lang="scss" scoped>
div[aria-invalid='true'] >>> .el-input__inner,
div[aria-invalid='true'] >>> .el-input__inner:focus {
  border-color: #f56c6c;
}

>>> .el-tree .el-tree-node__label {
  font-size: 14px;
}
>>> .import_row {
  margin-top: 15px;
  margin-bottom: 15px;
}
</style>
